var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnBoardingBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 340,
    viewBox: "0 0 375 340",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-97.091 176.946L8.87662 78.3312L142.811 117.948L248.411 24.54L372.589 66.3475",
    stroke: "url(#paint0_linear_60_275)",
    strokeWidth: 21
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-218.266 216.969L-80.3089 260.807L23.8272 167.728L159.226 207.016L253.605 116.128",
    stroke: "url(#paint1_linear_60_275)",
    strokeWidth: 21
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-80.0632 412.165L25.9045 313.55L159.839 353.166L265.439 259.759L389.617 301.566",
    stroke: "url(#paint2_linear_60_275)",
    strokeOpacity: 0.5,
    strokeWidth: 21
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-201.239 452.188L-63.2811 496.026L40.855 402.947L176.253 442.234L270.632 351.347",
    stroke: "url(#paint3_linear_60_275)",
    strokeOpacity: 0.5,
    strokeWidth: 21
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_60_275",
    x1: 122.302,
    y1: 52.8598,
    x2: 138.297,
    y2: 124.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFF2FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_60_275",
    x1: 33.1163,
    y1: 235.335,
    x2: 17.1213,
    y2: 164.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFF2FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_60_275",
    x1: 139.33,
    y1: 288.079,
    x2: 155.325,
    y2: 359.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFF2FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_60_275",
    x1: 50.1441,
    y1: 470.554,
    x2: 34.1492,
    y2: 399.328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFF2FF",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnBoardingBackground);
export default __webpack_public_path__ + "static/media/onBoardingBackground.413d9e44e09074d585d94b3835846791.svg";
export { ForwardRef as ReactComponent };